import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationAssetGroupSurvey = createCrudVuexModule({
  namespaced: true,
  path: "/asset-group",
  options: { localizedFields: ["name", "unit", "title"] },
  persistent: ["surveyGroup"],

  state: {
    surveyGroup: undefined,
    inProgressSurveyPagination: undefined,
    complatedSurveyPagination: undefined,
    memberPagination: undefined,
    resultsPagination: undefined,
    editedMember: undefined,
  },
  getters: {
    inProgressSurveyPagination: (state) => state.inProgressSurveyPagination,
    complatedSurveyPagination: (state) => state.complatedSurveyPagination,
    memberPagination: (state) => state.memberPagination,
    resultsPagination: (state) => state.resultsPagination,
    editedMember: (state) => state.editedMember,
    surveyGroup: (state) => state.surveyGroup,
  },
  mutations: {
    inProgressSurveyPagination: (state, value) => (state.inProgressSurveyPagination = value),
    complatedSurveyPagination: (state, value) => (state.complatedSurveyPagination = value),
    memberPagination: (state, value) => (state.memberPagination = value),
    resultsPagination: (state, value) => (state.resultsPagination = value),
    editedMember: (state, value) => (state.editedMember = value),
    surveyGroup: (state, value) => (state.surveyGroup = value),
  },
  actions: {
    async update({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`/asset-group-survey/`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async complateSurvey({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/asset-group-survey-group/complate-survey`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async createSurvey({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/asset-group-survey/`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchInProgressSurveys({ getters, commit, dispatch }, { pagination, assetGroupId }) {
      commit("isUpdating", true);
      try {
        const payload = { ...pagination, query: { ...pagination.query, status: { value: "IN_PROGRESS", isObject: true } } };
        const response = await rest.post(`/asset-group-survey/paginateWith`, { pagination: payload, id: assetGroupId });
        commit("inProgressSurveyPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchSurveyGroupDetail({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/asset-group-survey-group/${id}`);
        commit("surveyGroup", response.data);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async fetchComplatedSurveys({ getters, commit, dispatch }, { pagination, assetGroupId }) {
      commit("isUpdating", true);
      try {
        const payload = { ...pagination, query: { ...pagination.query, status: { value: "DONE", isObject: true } } };
        const response = await rest.post(`/asset-group-survey/paginateWith`, { pagination: payload, id: assetGroupId });
        commit("complatedSurveyPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchMembers({ getters, commit, dispatch }, pagination) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/asset-group-survey/member/paginate`, { pagination });
        commit("memberPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchResults({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/asset-group-survey/${id}/results`);
        commit("resultsPagination", response.data);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async saveMember({ getters, commit, dispatch }, { member, assetGroup }) {
      commit("isUpdating", true);
      try {
        const payload = await dispatch("preparePayload", {
          editedEntity: {},
          form: member,
        });

        let response;
        if (member && member._id) {
          response = await rest.put(`/asset-group-survey-group/`, { item: { _id: payload._id, participant: payload, assetGroup: assetGroup } });
        } else {
          response = await rest.post(`/asset-group-survey-group/`, { item: { surveyParticipant: payload, assetGroup: assetGroup } });
        }

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async deleteMember({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        await rest.delete(`/asset-group-survey/member/${id}`);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
